export default __webpack_public_path__ + "static/partnerIcon13-727ad89061790adde06a1e5c7dc2c7a2.svg";